(function showMoreModule(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  /**
   * Toggle hidden cards in a container and swap button text
   *
   * @function
   * @returns {void}
   */
  const toggleCards = (container, btn) => {
    const cardsContainer = container;
    const button = btn;

    if (!cardsContainer) {
      return;
    }
    const hiddenCards = [];
    const visibleCards = [];
    const cardsContainerChildren = cardsContainer.querySelectorAll(':scope > *'); // Select direct children only

    cardsContainerChildren.forEach((card) => {
      if (card.hasAttribute('hidden')) {
        hiddenCards.push(card);
      } else {
        visibleCards.push(card);
      }
    });

    const initialCardsInput = document.querySelector('[data-id=initialNumberOfCardsDisplayed]');
    const initialVisibleCards = initialCardsInput && initialCardsInput.value
      ? parseInt(initialCardsInput.value, 10)
      : 8;

    if (hiddenCards.length > 0) {
      // Show all hidden cards
      hiddenCards.forEach((card) => { card.removeAttribute('hidden'); });
      if (button) {
        button.textContent = 'Show less';
      }
    } else {
      // Hide all except the first initially visible cards
      visibleCards.slice(initialVisibleCards).forEach((card) => { card.setAttribute('hidden', 'true'); });
      if (button) {
        button.textContent = 'Show more';
        const target = document.getElementById(button.getAttribute("data-target"));
        if (target) {
          target.scrollIntoView();
        }
      }
    }
  };

  /**
   * Handles the Show/Hide button functionality.
   *
   * @function
   * @returns {void}
   */
  const handleShowHideButtons = () => {
    const showHideButtons = document.querySelectorAll('[data-more-button]');
    showHideButtons.forEach((btn) => {
      btn.addEventListener('click',
        () => {
          const container = btn.closest('[data-homes-container]');
          if (!container) {
            return;
          }

          const plansContainer = container.querySelector('#plans-container');
          const specsContainer = container.querySelector('#specs-container');
          const buttonDataId = btn.getAttribute('data-id');

          if (plansContainer && buttonDataId === 'plan-more-button') {
            toggleCards(plansContainer, btn);
          }
          if (specsContainer && buttonDataId === 'spec-more-button') {
            toggleCards(specsContainer, btn);
          }
        });
    });
  };

  handleShowHideButtons();
}(window));
